// extracted by mini-css-extract-plugin
export var progressContainer = "_ih-0";